<template>
  <div class="not-found-wrapper">
    <div class="content-container">
      <div class="max-w-md w-full text-center">
        <!-- 404 Icon -->
        <div class="mb-8">
          <div
            class="w-32 h-32 mx-auto bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center shadow-lg"
          >
            <svg class="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </div>
        </div>

        <!-- Error Message -->
        <div class="mb-8">
          <h1 class="text-6xl font-bold text-gray-800 mb-4">404</h1>
          <h2 class="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
          <p class="text-gray-600 leading-relaxed">
            Sorry, the page you're looking for doesn't exist or has been moved. Let's get you back
            on track!
          </p>
        </div>

        <!-- Action Buttons -->
        <div class="space-y-4">
          <button
            @click="goHome"
            class="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold py-3 px-6 rounded-lg shadow-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 cursor-pointer"
          >
            <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              ></path>
            </svg>
            Go Home
          </button>

          <button
            @click="goBack"
            class="w-full bg-white text-gray-700 font-semibold py-3 px-6 rounded-lg border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 cursor-pointer"
          >
            <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              ></path>
            </svg>
            Go Back
          </button>
        </div>

        <!-- Help Text -->
        <div class="mt-8 text-sm text-gray-500">
          <p>If you believe this is an error, please contact our support team.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { logInfo } from "@/utils/secureLogger";

const router = useRouter();

const goHome = () => {
  logInfo("User navigated to home from 404 page");
  router.push("/");
};

const goBack = () => {
  logInfo("User navigated back from 404 page");
  // Check if there's a previous page in history
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    // If no history, go to home
    router.push("/");
  }
};
</script>

<style scoped>
.not-found-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: url("/student-reg-bg.png") center top/100% auto no-repeat;
  background-attachment: fixed;
  padding: 1rem;
  position: relative;
  width: 100%;
}

.content-container {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 1.5rem;
  padding: 3rem 2rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  max-width: 28rem;
  width: 100%;
}

@media (max-width: 640px) {
  .content-container {
    padding: 2rem 1.5rem;
  }
}
</style>
